interface ImageButton {
  text: string;
  altText: string;
  overlay: boolean;
  opacity: number;
  desc: string;
  image: string;
}

const bridgeImages: Array<ImageButton> = [
  {
    text: "",
    altText: "",
    overlay: false,
    opacity: 0,
    desc:
      "Designed as a through-truss bridge and built in 1952, the Calcasieu River Bridge is eligible for the National Register of Historic Places because its design and engineering represent an important phase in the history of bridge building and transportation in Louisiana.  However, the bridge is not a candidate for long-term preservation through rehabilitation.",
    image: "calcasieu-river-bridge.jpg"
  },
  {
    text: "",
    altText: "",
    overlay: false,
    opacity: 0,
    desc:
      "The Calcasieu River Bridge was originally built as part of the Calcasieu-Lake Charles Highway (US Highway 90). The highway and bridge from Westlake to Lake Charles were incorporated into the interstate system 10 years later as a key link in Interstate 10.",
    image: "calcasieu-lake-charles.jpg"
  },
  {
    text: "",
    altText: "",
    overlay: false,
    opacity: 0,
    desc:
      "Repairs to the ornamental railing have included replacement of some parts of the famous 1948 cross pistols designed for the bridge in honor of Jean Lafitte and the area’s pirate history.",
    image: "ornamental-railing.jpg"
  },
  {
    text: "",
    altText: "",
    overlay: false,
    opacity: 0,
    desc:
      "An example of functional deficiency is the overhead clearance at the top of the bridge. Current design criteria call for 16’ to 16’-6”. ",
    image: "functional-deficiency.png"
  },
  {
    text: "",
    altText: "",
    overlay: false,
    opacity: 0,
    desc:
      "A rule-of-thumb for the useful life of a bridge is 50 years. Timely maintenance has extended the structural life of the bridge, but partial measures are no longer economically reasonable and changes in functional features that would require widening are not physically possible.",
    image: "life-of-bridge.jpg"
  },
  {
    text: "",
    altText: "",
    overlay: false,
    opacity: 0,
    desc:
      "Deterioration over time causes cracking, fragmentation, and loss of concrete on the bridge deck. The bridge is still structurally safe but repairs to parts affected by deterioration are costly and have serious effects on traffic.",
    image: "deterioration-over-time.jpg"
  }
];

const roadwayImages: Array<ImageButton> = [
  {
    text: "",
    altText: "",
    overlay: false,
    opacity: 0,
    desc:
      "The mainline of I-10 between the two interchanges, including the Calcasieu River Bridge, is generally four lanes (two lanes in each direction). Additional outside lanes found within the corridor are limited to use by traffic entering and exiting the interstate.",
    image: "four-lanes.jpg"
  },
  {
    text: "",
    altText: "",
    overlay: false,
    opacity: 0,
    desc:
      "Traffic congestion on the I-10 Service Road as vehicles line up to turn left on to Sampson Street.",
    image: "traffic-congestion.jpg"
  },
  {
    text: "",
    altText: "",
    overlay: false,
    opacity: 0,
    desc:
      "Traffic congestion on Sampson Street during afternoon peak hour. Far left traffic is headed west on I-10; middle lane traffic is headed east on I-10.  Third lane leads to left turn for Isle of Capri Boulevard. ",
    image: "sampson-street.jpg"
  },
  {
    text: "",
    altText: "",
    overlay: false,
    opacity: 0,
    desc:
      "All lanes on northbound Sampson Street blocked by train, crash, or other unpredictable event is a common occurrence.",
    image: "common-traffic.jpg"
  },
  {
    text: "",
    altText: "",
    overlay: false,
    opacity: 0,
    desc:
      "Mainline overpass bridge of Enterprise Avenue at Belden (I-10 Service Road [southside]) will be reconstructed to increase the vertical clearance and the embankments will be replaced with a continuous bridge structure.",
    image: "enterprise-avenue.jpg"
  },
  {
    text: "",
    altText: "",
    overlay: false,
    opacity: 0,
    desc:
      "Curves and geometric features in some areas like this section of eastbound I-10 approaching US 171 will be improved so that higher interstate speeds can be safely maintained.",
    image: "higher-interstate-speed.jpg"
  }
];

const publicMeetingImages: Array<ImageButton> = [
  {
    text: "",
    altText: "",
    overlay: false,
    opacity: 0,
    desc: "",
    image: "project-status-1.jpg"
  },
  {
    text: "",
    altText: "",
    overlay: false,
    opacity: 0,
    desc: "",
    image: "project-status-2.jpg"
  },
  {
    text: "",
    altText: "",
    overlay: false,
    opacity: 0,
    desc: "",
    image: "project-status-3.jpg"
  }
];

export { ImageButton, bridgeImages, roadwayImages, publicMeetingImages };
